import { VALID, severity } from '@gef-ui/validations/constants';
import T from "ramda/es/T";
import always from "ramda/es/always";
import cond from "ramda/es/cond";
import equals from "ramda/es/equals";
import keyMirror from "ramda-extension/es/keyMirror";
export const formActions = keyMirror({
    REPLACE_DATA: null,
    INCREMENT_STEP: null,
    DECREMENT_STEP: null,
    SET_STEP: null,
    RESET_FORM: null,
    UPDATE_FIELD_VALUE: null,
    DEFAULT_FIELD_VALUE: null,
    SUBMIT: null
});
export const flowFormActions = keyMirror({
    TRANSITION_START: null,
    TRANSITION_END: null
});
export const transitionDescriptorActions = keyMirror({
    REGISTER_TRANSITION_DESCRIPTOR: null
});
export const typeColor = (prefix)=>cond([
        [
            equals(severity.ERROR),
            always(`${prefix}--typeError`)
        ],
        [
            equals(severity.WARNING),
            always(`${prefix}--typeWarning`)
        ],
        [
            T,
            always(undefined)
        ]
    ]);
export const validationColor = typeColor('Validation');
export const inputColor = typeColor('Input');
export const checkboxColor = typeColor('Checkbox');
export const radioColor = typeColor('Radio');
export const fieldTypes = keyMirror({
    AUTOCOMPLETE: null,
    AUTOCOMPLETE_CODELIST: null,
    SELECT: null,
    SELECT_CODELIST: null,
    TEXT_FIELD: null,
    DISPLAY_TEXT_FIELD: null,
    DATE_PICKER: null,
    DATE_PICKER_MUI: null,
    KEYBOARD_DATE_PICKER_MUI: null,
    DATE_TIME_PICKER_MUI: null,
    TIME_PICKER_MUI: null,
    SPINNER: null,
    CHECKBOX: null,
    RADIO: null,
    FILE_INPUT: null,
    SWITCH: null,
    TAGS_INPUT: null
});
export const fieldActions = keyMirror({
    REGISTER_FIELD: null,
    UNREGISTER_FIELD: null
});
export const defaultFieldState = ({ initiallyDirty })=>({
        valid: VALID,
        pristine: !initiallyDirty
    });
export const formState = keyMirror({
    VALID: null,
    INVALID: null,
    IN_PROGRESS: null
});
